import React from 'react';
import { FileCheck2Icon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
import { pathwaySteps } from '../../data/content';
export function Pathway() {
  return <section className="w-full bg-panel py-16 sm:py-24" data-id="element-267" data-mp="4cvomd2d0adp">
      <div className="mx-auto max-w-6xl px-4" data-id="element-268" data-mp="9byid1cw2u6d">
        <SectionHeading kicker="Introducing" title={<>The No-Start <span className="text-brand" data-id="element-270" data-mp="38rvgfwbfc30t">Diagnostic Pathway™</span></>} subtitle="A practical 6-step system for organizing vehicle no-start investigations." data-id="element-269" data-mp="9anel1jg1mf9" />

        <div className="mx-auto mt-8 max-w-3xl space-y-3 text-center text-lg leading-relaxed text-body" data-id="element-271" data-mp="3hqp7l75zk16z">
          <p data-id="element-272" data-mp="3mqlcr9qf5yo4">The Automotive No-Start Diagnostic Blueprint™ is not another automotive theory textbook.</p>
          <p data-id="element-273" data-mp="x1swdm8y2os7">
            It’s a practical collection of diagnostic workflows designed for technicians who need a structured way to investigate
            vehicles that refuse to start. Instead of presenting hundreds of possible causes without direction, the system organizes
            the investigation into six stages.
          </p>
        </div>

        <ol className="relative mx-auto mt-12 max-w-3xl" data-id="element-274" data-mp="182337tvejte0">
          {pathwaySteps.map((step, i) => <li key={step.title} className="relative flex gap-4 pb-8 last:pb-0 sm:gap-6" data-id="element-275" data-mp="136nsvbwlsfmc" data-mpi={i}>
              {i < pathwaySteps.length - 1 && <span className="absolute left-[27px] top-14 h-[calc(100%-56px)] w-0.5 bg-line sm:left-[31px]" aria-hidden="true" data-id="element-276" data-mp="t6wzjdjs46nu" />}
              <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-brand font-display text-3xl font-black text-ink sm:h-16 sm:w-16 sm:text-4xl" data-id="element-277" data-mp="odu0wr05a70s">
                {i + 1}
              </span>
              <div className="min-w-0 flex-1 pt-1" data-id="element-278" data-mp="ag5o86g8e66t">
                <p className="font-display text-base font-bold uppercase tracking-wide text-alert" data-id="element-279" data-mp="afnmwvepp1s1">Step {i + 1}</p>
                <h3 className="font-display text-2xl font-extrabold uppercase leading-tight text-white sm:text-3xl" data-id="element-280" data-mp="5huedvpxrvol">{step.title}</h3>
                <p className="mt-2 text-base leading-relaxed text-body sm:text-lg" data-id="element-281" data-mp="s9x5imesttq">{step.text}</p>
                <p className="mt-3 flex items-start gap-2 rounded-xl bg-ink p-3 text-sm font-semibold text-white sm:text-base" data-id="element-282" data-mp="3iyfupfpcjgc6">
                  <FileCheck2Icon className="mt-0.5 h-5 w-5 shrink-0 text-ok" aria-hidden="true" data-id="element-283" data-mp="3n0szo1w9ra7w" />
                  <span data-id="element-284" data-mp="ekzjjo5uo0rd">
                    <span className="text-ok" data-id="element-285" data-mp="ekhnarj6tmjg">Your deliverable:</span> {step.deliverable}
                  </span>
                </p>
              </div>
            </li>)}
        </ol>

        <div className="mx-auto mt-12 max-w-3xl text-center" data-id="element-286" data-mp="5r4ppca6hwr1">
          <p className="font-display text-3xl font-extrabold uppercase text-white sm:text-4xl" data-id="element-287" data-mp="9spvkdoaparq">
            Six stages. <span className="text-brand" data-id="element-288" data-mp="xik78rwvotae">One repeatable process.</span>
          </p>
          <p className="mt-4 text-lg text-body" data-id="element-289" data-mp="12a2ajmmdj5yj">
            By following the pathway, you can organize an investigation from the initial complaint through a documented next-step
            decision.
          </p>
          <p className="mt-3 text-sm text-muted" data-id="element-290" data-mp="2i1mnjzrmcp4h">
            The actual tests required depend on the vehicle, symptoms, manufacturer procedures, and available equipment.
          </p>
        </div>

        <CtaButton className="mt-10" label="Start Following the 6-Step Pathway" data-id="element-291" data-mp="2rqebzxxh0ran" />
      </div>
    </section>;
}